import { ContentInsight } from '../content-insight.interface';
import { formatDuration } from 'src/utils/date';

export const getTotalViews = (contentInsight: ContentInsight) => {
  return contentInsight.total_views;
};

export const getAverageViewTime = (contentInsight: ContentInsight) => {
  const averageTime = contentInsight.average_time;
  return averageTime ? formatDuration(averageTime) : '-';
};

export const getMedianViewTime = (contentInsight: ContentInsight) => {
  const medianTime = contentInsight.median_time || 0;
  return medianTime ? formatDuration(medianTime) : '-';
};

export const getUsedInJourneys = (contentInsight: ContentInsight) => {
  return contentInsight.journeys.length;
};

export const getClickThroughRate = (contentInsight: ContentInsight) => {
  const totalContentViews = contentInsight.total_views;
  const totalJourneyViews = contentInsight.journeys.reduce(
    (acc: number, journey: any) => acc + (journey.total_journey_views || 0),
    0
  );
  const clickThroughRate = Math.round((totalContentViews / totalJourneyViews) * 100);
  return totalJourneyViews > 0 ? `${clickThroughRate > 100 ? 100 : clickThroughRate}%` : '-';
};
